import { useEffect, useRef, Fragment } from 'react';
import { useRecoilValue } from 'recoil';
import { currentEnvironment } from '../Recoil-State';
import { Messages } from 'primereact/messages';

const pt ={
  root:{ className:'m-0'},
  text: { className:'p-0 text-xs'}
}
export const AlertMessage = () => {
  const msgs = useRef(null);
  let ENV = useRecoilValue(currentEnvironment);
  const getSession = () => {
    return sessionStorage.getItem("isPopupClose") !== null ? true : false;
  };

  useEffect(() => {
    if (!getSession() && ENV !== "prod") {
      msgs.current &&
        msgs.current.show({
          sticky: true,
          severity: "warn",
          className:'alert-info',
          content: (
            <div className='text-xs flex align-items-center '>
              <i className='pi pi-info-circle mr-2'/>
            Warning! This is not a Production environment.
            Use  &nbsp;
            <a 
              
                href="https://fxhub.astrazeneca.com/" target="_blank"  rel="noreferrer" className='underline text-blue-500	'> this link </a> &nbsp;  
            to access FX Hub Production. You’re currently in the {ENV}  environment.
            </div>
          ),
          closable: true,
        });
    }
    // eslint-disable-next-line
  }, []);

  const onRemoveMessage = (e) => {
    sessionStorage.setItem("isPopupClose", true);
  };

  if (ENV === "prod") {
    return null;
  }

  return <Messages ref={msgs} pt ={pt} onRemove={onRemoveMessage} className ="alert-custom m-0" />;
};